<template>
  <nav>
    <!-- navbar重構 -->
    <div class="navbar">
      <div class="Logo">
        <a title="前往首頁" href="/">
          <router-link :to="{ name: 'TheHome' }">
            <img
              style="width: 80px; height: 80px"
              src="@/assets/image/logo.jpg"
              alt=""
            />
          </router-link>
        </a>
      </div>
      <div class="MenuSwitch">
        <v-avatar
          class="MenuStyle"
          :class="{ close_side: barswitch }"
          tile
          size="80"
          color="#F29100"
        >
          <a @click="barswitch = !barswitch" color="error" href="#">
            <v-icon size="30" v-show="!barswitch" class="" dark>
              mdi-menu
            </v-icon>
            <v-icon size="30" v-show="barswitch" class="" dark>
              mdi-close
            </v-icon>
          </a>
        </v-avatar>
      </div>
    </div>

    <div class="menu" :class="{ menuOpen: barswitch }">
      <v-avatar
        class="close"
        :class="{ close_side: barswitch }"
        size="80"
        tile
        color="#F29100"
      >
        <a @click="barswitch = !barswitch" color="error" href="#">
          <v-icon v-show="!barswitch" class="text-h4" dark> mdi-menu </v-icon>
          <v-icon v-show="barswitch" class="text-h4" dark> mdi-close </v-icon>
        </a>
      </v-avatar>
      <a title="前往首頁" href="/">
        <router-link :to="{ name: 'TheHome' }">
          <img src="@/assets/image/logo.jpg" alt="" />
        </router-link>
      </a>
      <ul>
        <li>
          <p>
            <router-link :to="{ name: 'About' }">
              {{ items[0].text }}
            </router-link>
          </p>
        </li>
        <li>
          <p>
            <router-link :to="{ name: 'News' }">
              {{ items[1].text }}
            </router-link>
          </p>
        </li>
        <li>
          <p>
            <router-link :to="{ name: 'Room' }">
              {{ items[2].text }}
            </router-link>
          </p>
        </li>
        <li>
          <p>
            <a href="https://pescadores.ezhotel.com.tw/3">
              {{ items[3].text }}
            </a>
          </p>
        </li>
        <li>
          <p>
            <router-link :to="{ name: 'Traffic' }">
              {{ items[4].text }}
            </router-link>
          </p>
        </li>
      </ul>
      <div class="icon_position">
        <a href="#">
          <v-icon size="30"> mdi-facebook-messenger </v-icon>
        </a>
        <a
          target="_blank"
          href="https://www.facebook.com/pages/%E4%BD%B3%E6%9C%9F%E5%A4%A7%E9%A3%AF%E5%BA%97/159513774099200"
        >
          <v-icon size="30"> mdi-facebook </v-icon>
        </a>
      </div>
    </div>
    <!-- navbar重構 -->
  </nav>
</template>

<script>
import $ from "jquery";

export default {
  data: () => ({
    barswitch: false,
    selectedItem: 0,
    items: [
      { text: "關於我們", link: "/about" },
      { text: "最新消息", link: "/News" },
      { text: "房型介紹", link: "/Room" },
      { text: "線上訂房" },
      { text: "交通資訊​", link: "/Traffic" },
    ],
    direction: "top",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: "scale-transition",
  }),
  computed: {
    activeFab() {
      switch (this.tabs) {
        case "one":
          return { class: "purple", icon: "account_circle" };
        case "two":
          return { class: "red", icon: "edit" };
        case "three":
          return { class: "green", icon: "keyboard_arrow_up" };
        default:
          return {};
      }
    },
  },
  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/side_bar/SideBar.scss";
.Mobile_menu {
  position: sticky;
  top: 20%;
}
@media screen and (max-width: 600px) {
  // .sidebar {
  //   background-color: #ffffff;
  //   width: 15vw;
  //   height: 100vh;
  //   box-shadow: 1px 1px 20px 0px rgb(209, 195, 195);
  //   margin-left: -15%;
  //   opacity: 0;
  //   transition: $TransitionAnimation;
  // }
}
</style>
